import React, { useState, useCallback, useLayoutEffect } from "react";
import HttpAction from "modules/utils/HttpAction";
import {useHistory} from "react-router-dom";

const ContestContext = React.createContext({
  state: {
      contestList: [],
      endContestList: [],
      contest: {},
      contestId: "",
      regStatus: {},
      totalContestInfo:{},
      joinContestStatus: false,
      confirmModal:{
          state : false,
          msg : "",
          info : "",
          handleClose: ()=>{}
      },
      contestListMain: []
  },
  actions: {
    getContestList: () => {},
    getContest: () => {},
    createContest: () => {},
    setContestFileInfo: () => {},
    getEndContestList: () => {},
    getTotalContestInfo: () => {},
    joinContest: () => {},
   agreeContest: () => {}
  },
});

const ContestProvider = ({ children }) => {
    const history = useHistory();
    const [contest, setContest] = useState({});
    const [contestList, setContestList] = useState([]);
    const [contestId, setContestId] = useState();
    const [endContestList, setEndContestList] = useState([]);
    const [regStatus, setRegStatus] = useState({
        type : null,
        status: false
    });
    const [totalContestInfo, setTotalContestInfo] = useState();
    const [joinContestStatus, setJoinContestStatus] = useState(false);
    const [confirmModal, setConfirmModal] = useState({
        state : false,
        msg : "",
        info : "",
        handleClose: ()=>{}
    }); //챌린지 임시저장/등록/수정하기 알림팝업

    const [contestListMain, setContestListMain] = useState([])

 // 대회참가
    const joinContest = useCallback((param, contestId) => {

        HttpAction({
            url: "/member/contest/join",
            // url: "/contest",
            method: "post",
            data: {
                contestId: contestId && contestId,
                contestTeamMemberList: param && param.contestTeamMemberList,
                email: param && param.email,
                grade: param && param.grade,
                institueName: param && param.institueName,
                major: param && param.major,
                name: param && param.name,
                phoneNumber: param && param.phoneNumber,
                teamName: param && param.teamName
            }
        }).then((res) => {
            if (res.code === 200) {
                // setJoinContestStatus(true);
                console.log("joinContest success", res)
                alert("참여가 완료되었습니다")
                document.location.href = `/convention/${contestId}/viewSummary`;
            } else {
                // setJoinContestStatus(false)
                 console.log("joinContest error", res)
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });

    }, []);

  //부서 조회
  const getContest = useCallback((id) => {
    HttpAction({
      url: "/member/contest",
        // url: "/contest",
      method: "get",
      params: {
        contestId: id,
      }
    }).then((res) => {
      if (res.code === 200) {
          if(res.data) {
              console.log(res.data)
            setContest(res.data);
          }
      } else {
          // alert(res.message);
          sessionStorage.removeItem("jwt");
          sessionStorage.removeItem("userId");
          sessionStorage.removeItem("isAdmin");
          sessionStorage.removeItem("loginid");
          let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
          // document.location.href = "/main"
      }
    }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }, []);

   //부서 조회
   const getContestList = useCallback((params, type) => {
        HttpAction({
          url: "/member/contest/list",
          method: "post",
          data: {
              ...params,
              contestTitle: params && params.contestTitle,
              page: params && params.page,
              records: params && params.records,
              smallCategories: params?.smallCategories ? params.smallCategories : [],
              status: params?.status ? params.status : "",
              orderBy: params?.orderBy ? params.orderBy : "",
          }
        }).then((res) => {
          if (res.code === 200) {
              if(type === "mainContestList") {
                  setContestListMain(res.data);
              } else {
                  setContestList(res.data);
              }
          } else {
              // alert(res.message);
              sessionStorage.removeItem("jwt");
              sessionStorage.removeItem("userId");
              sessionStorage.removeItem("isAdmin");
              sessionStorage.removeItem("loginid");
              let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
              // document.location.href = "/main"
          }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
  }, []);

// 대회 생성 & 수정
  const createContest = (params) => {
      console.log("params >>> ", params);
    HttpAction({
        url: "/admin/contest",
        method: "post",
        data: params,
        headers: { "Content-Type": "text/plain" }
    }).then((res) => {
        if (res.code === 200) {
            // setContestId(res.data)
            // getContestList();
            sessionStorage.setItem("contestId", res.data);

            let message = "";
            //이미 임시 혹은 등록 된상태
            if(params.contestInfo.contestId && params.contestInfo.contestId != undefined){
                if(params.contestInfo.tempFlg == "Y"){
                    message = "임시저장이 완료 되었습니다.";
                }else if(params.contestInfo.tempFlg == "N"){
                    message = "수정이 완료 되었습니다.";
                }
            //최초 임시 혹은 등록 할때
            }else{
                if(params.contestInfo.tempFlg == "Y"){
                    message = "임시저장이 등록 되었습니다.";
                }else if(params.contestInfo.tempFlg == "N"){
                    message = "챌린지 등록 신청 되었습니다.";
                }
            }

          setConfirmModal({
                state: true,
                msg: "안내 문구",
                info:  message,
                handleClose: () => {
                    document.location.href="/admin";
                }
          });

        } else {
          console.log("메뉴 생성에 실패했습니다.", res);
        }
      }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }

  const setContestFileInfo = (fileInfo) => {
      setContestFileInfo([fileInfo])
  }

    // 임시 종료 챌린지 리스트 (위 함수가 또 어디 쓰일지 모르므로)
    const getEndContestList = useCallback((params) => {
        HttpAction({
            url: "/admin/user/joincontest",
            method: "get",
            params: {
                page: params && params.page,
                records: params && params.records,
                useFlg: params && params.useFlg
            }
        }).then((res) => {
            if (res.code === 200) {
                setEndContestList(res.data);
            } else {
                // alert(res.message);
                sessionStorage.removeItem("jwt");
                sessionStorage.removeItem("userId");
                sessionStorage.removeItem("isAdmin");
                sessionStorage.removeItem("loginid");
                let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
                // document.location.href = "/main"
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, []);

    const getTotalContestInfo = useCallback(() => {
        HttpAction({
            url: "/member/contest/total",
            method: "get"
        }).then((res) => {
            if (res.code === 200) {
                setTotalContestInfo(res.data);

            } else {
                // alert(res.message);
                sessionStorage.removeItem("jwt");
                sessionStorage.removeItem("userId");
                sessionStorage.removeItem("isAdmin");
                sessionStorage.removeItem("loginid");
                let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
                // window.location.href = "http://localhost:3000/main"
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, []);

    // 챌린지 참여 동의
    const agreeContest = contestId  => {
        HttpAction({
            url: "/member/contest/insertAgreement",
            method: "post",
            params : {
                contestId: contestId  && contestId,
            }
        }).then((res) => {
            if (res.code === 200) {
                console.log("챌린지 참여 동의성공했습니다.");
                alert("챌린지 참여에 동의 하였습니다.")
                getContest(contestId )
            } else {
                console.log("챌린지 참여 동의 실패했습니다.");
                alert("챌린지 참여 동의 실패했습니다.")
                // document.location.href = "/login";
                // document.location.href = `${process.env.REACT_APP_BIG_DATA_PLATFORM}/inno/login`;
                window.location.href = `${process.env.REACT_APP_FRONT_URL}/main`
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }




    useLayoutEffect(() => {

     setJoinContestStatus(null);

    if (sessionStorage.getItem("contestId") == null) {
        setContestId(null)
        return
    }
    
    let contestIdInStorage = sessionStorage.getItem("contestId")

    if(contestIdInStorage) {
        setContestId(contestIdInStorage) 
    }

  }, []);

  const value = {
    state: { contest, contestList, contestId, endContestList, regStatus, totalContestInfo, joinContestStatus, confirmModal, contestListMain },
    actions: { agreeContest, getContest, getContestList, createContest, setContestFileInfo, getEndContestList, getTotalContestInfo, joinContest, setJoinContestStatus, setConfirmModal },
  };

  return (
    <ContestContext.Provider value={value}>
      {children}
    </ContestContext.Provider>
  );
};

const { Consumer: ContestConsumer } = ContestContext;

export { ContestProvider, ContestConsumer, ContestContext };

export default ContestContext;
